// YouTube links for the UI. Environment-neutral (browser + Node).
//
// Video-ID parsing lives in ./youtube/videoId.ts (shared with the transcript layer); this module
// re-exports it under the names the web app uses and adds the URLs the UI builds.
//
// parseYouTubeVideoId(input) accepts a bare ID, every common YouTube link form, text containing a
// link, and paths relative to youtube.com or to this app (`/watch?v=ID`, `/shorts/ID`, `/ID`,
// `/?v=<id or url>`, `/https:/www.youtube.com/watch?v=ID`), so it also serves the address-bar
// "replace youtube.com by our host" trick. Returns null when no video ID can be found.

import { isValidVideoId } from './youtube/videoId';

export { parseYouTubeVideoId } from './youtube/videoId';

export function isYouTubeVideoId(value: string): boolean {
  return isValidVideoId(value);
}

export function youTubeWatchUrl(videoId: string): string {
  return `https://www.youtube.com/watch?v=${encodeURIComponent(videoId)}`;
}

export function youTubeThumbnailUrl(videoId: string, quality: 'hqdefault' | 'mqdefault' = 'hqdefault'): string {
  return `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/${quality}.jpg`;
}
